var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',[_c('v-tab',{attrs:{"to":"/kpi"}},[_vm._v("日次")]),_c('v-tab',{attrs:{"to":"/kpi/monthly"}},[_vm._v("月次")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }